import React, { useState } from 'react';
import { 
  Form, 
  Input, 
  Button, 
  Card, 
  message, 
  Select, 
  Typography,
  Divider
} from 'antd';
import { useNavigate } from 'react-router-dom';
import AppHeader from '../../components/Header';
import AppFooter from '../../components/Footer';
import { useUser } from '../../utils/userContext';
import './index.css';

const { Title } = Typography;
const { TextArea } = Input;

const WritePost = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { user } = useUser();
  const [loading, setLoading] = useState(false);

  if (!user) {
    navigate('/login');
    return null;
  }

  const handlePublish = async (values) => {
    setLoading(true);
    
    try {
      const articleId = Date.now().toString();

      const date = new Date().toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });

      const articleData = {
        id: articleId,
        title: values.title,
        content: values.content,
        abstract: values.abstract || values.content.substring(0, 100) + '...',
        tags: values.tags || [],
        date: date,
        author: user.username,
        authorId: user.id
      };

      const storedArticles = JSON.parse(localStorage.getItem('articles') || '[]');

      storedArticles.unshift(articleData);

      localStorage.setItem('articles', JSON.stringify(storedArticles));
      
      message.success('文章发布成功！');

      navigate('/');
    } catch (error) {
      message.error('发布文章失败，请重试');
      console.error('Error publishing article:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveDraft = async (values) => {
    setLoading(true);
    
    try {
      message.success('草稿已保存！');
    } catch (error) {
      message.error('保存草稿失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="write-post-page">
      <AppHeader />
      <div className="write-post-container">
        <Card className="write-post-card">
          <Title level={2} className="write-post-title">写文章</Title>
          <Divider />
          
          <Form
            form={form}
            layout="vertical"
            onFinish={handlePublish}
            autoComplete="off"
          >
            <Form.Item
              name="title"
              label="文章标题"
              rules={[{ required: true, message: '请输入文章标题' }]}
            >
              <Input 
                placeholder="请输入文章标题" 
                size="large" 
                maxLength={100}
                showCount
              />
            </Form.Item>

            <Form.Item
              name="abstract"
              label="文章摘要"
            >
              <TextArea 
                rows={4} 
                placeholder="请输入文章摘要（可选，如不填写将自动截取文章内容前100字）" 
                maxLength={200}
                showCount
              />
            </Form.Item>

            <Form.Item
              name="content"
              label="文章内容"
              rules={[{ required: true, message: '请输入文章内容' }]}
            >
              <TextArea 
                rows={12} 
                placeholder="开始写作..." 
                maxLength={10000}
                showCount
              />
            </Form.Item>

            <Form.Item
              name="tags"
              label="标签"
              extra="按回车键添加标签，最多5个"
            >
              <Select
                mode="tags"
                placeholder="添加标签"
                maxTagCount={5}
                tokenSeparators={[',', '，', ' ']}
              >
              </Select>
            </Form.Item>

            <Form.Item className="write-post-actions">
              <Button 
                type="default" 
                onClick={() => navigate('/')}
                style={{ marginRight: 16 }}
              >
                取消
              </Button>
              
              <Button 
                type="primary" 
                htmlType="submit" 
                loading={loading}
                style={{ marginRight: 16 }}
              >
                发布
              </Button>
              
              <Button 
                type="default"
                onClick={() => {
                  form.validateFields().then(values => {
                    handleSaveDraft(values);
                  }).catch(() => {
                    message.warning('请填写必填字段后再保存草稿');
                  });
                }}
                loading={loading}
              >
                保存草稿
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
      <AppFooter />
    </div>
  );
};

export default WritePost;